// Navigation Icons
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import PersonIcon from "@mui/icons-material/PersonOutlined";
import ReceiptIcon from "@mui/icons-material/ReceiptOutlined";
import HomeWork from "@mui/icons-material/HomeWork";
import PermMediaOutlinedIcon from "@mui/icons-material/PermMediaOutlined";
import PowerOffOutlinedIcon from "@mui/icons-material/PowerOffOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from "@mui/icons-material/SettingsOutlined";

// Sub-menu Icons
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import AddBoxIcon from '@mui/icons-material/AddBox';
import FaceRoundedIcon from '@mui/icons-material/FaceRounded';
import LockOpenIcon from "@mui/icons-material/LockOpenOutlined";
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';
import CodeIcon from "@mui/icons-material/Code";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DownloadIcon from "@mui/icons-material/Download";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import EditCalendar from "@mui/icons-material/EditCalendar";
import SettingsPower from "@mui/icons-material/SettingsPower";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Dashboard } from "@mui/icons-material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DescriptionIcon from "@mui/icons-material/Description";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ComplaintsSidebarBadges from "layout-components/Sidebar/ComplaintsSidebarBadges";

/**
 * Application Navigation Structure
 * Each navigation item can have:
 * - label: Display text
 * - icon: Material-UI icon component
 * - to: Route path (for single items)
 * - content: Sub-menu items array (for expandable items)
 */

const navigationItems = [
  {
    label: "Dashboard",
    icon: HomeOutlinedIcon,
    to: "/dashboard"
  },
  {
    label: "Customers",
    icon: ContactMailIcon,
    to: "/accounts"
  },
  {
    label: "Users",
    icon: PersonIcon,
    to: "/users"
  },
  {
    label: "Bills",
    icon: ReceiptIcon,
    content: [
      {
        label: "Billing Dashboard",
        icon: DashboardTwoToneIcon,
        to: "/billingdashboard"
      },
      {
        label: "Bill Property",
        icon: AddBoxIcon,
        to: "/billingwizard/new"
      }
    ]
  },
  {
    label: "Properties",
    icon: HomeWork,
    content: [
      {
        label: "Locations",
        icon: LocationOnIcon,
        to: "/properties"
      },
      {
        label: "Managers",
        icon: FaceRoundedIcon,
        to: "/property-managers"
      },
      {
        label: "Owners",
        icon: LockOpenIcon,
        to: "/owners"
      },
      {
        label: "Developers",
        icon: WorkRoundedIcon,
        to: "/developers"
      },
      {
        label: "Vendors",
        icon: LocalShippingOutlinedIcon,
        to: "/vendors"
      },
      {
        label: "Rate References",
        icon: DescriptionIcon,
        to: "/rate-reference"
      },
      {
        label: "Work Orders",
        icon: BuildRoundedIcon,
        to: "/workorders"
      },
    ]
  },
  {
    label: "Management",
    icon: PermMediaOutlinedIcon,
    content: [
      {
        label: "Api Keys",
        icon: CodeIcon,
        to: "/api-keys"
      },
      {
        label: "Bulk Check",
        icon: AccountBalanceIcon,
        to: "/bulkcheckentry"
      },
      {
        label: "Billing Pdf Download",
        icon: DownloadIcon,
        to: "/billingpdf"
      },
      {
        label: "Import Meter Readings",
        icon: PresentToAllIcon,
        to: "/meter-readings-upload"
      },
      {
        label: "Lockbox",
        icon: LockOpenIcon,
        to: "/lockbox-upload"
      }
    ]
  },
  {
    label: "Disconnection Center",
    icon: SettingsPower,
    content: [
      {
        label: "Disconnect Command Center",
        icon: Dashboard,
        to: "/disconnect-command-center"
      },
      {
        label: "Property and Group Management",
        icon: HomeWorkOutlinedIcon,
        to: "/disconnect-management"
      },
      {
        label: "Disconnect Schedules",
        icon: EditCalendar,
        to: "/disconnect-schedules"
      },
      {
        label: "Account Disconnects",
        icon: PowerOffOutlinedIcon,
        to: "/disconnect"
      },
      {
        label: "Contract Invoices",
        icon: ReceiptLongIcon,
        to: "/contract-invoices"
      },
    ]
  },
  {
    label: "Complaints",
    icon: ReportProblemOutlinedIcon,
    to: "/complaints",
    badge: ComplaintsSidebarBadges,
  },
  {
    label: "Move Ins/Outs",
    icon: TransferWithinAStationIcon,
    to: "/move-ins-outs"
  },
  {
    label: "Accounting",
    icon: LocalAtmIcon,
    to: "/accounting"
  },
  {
    label: "Reports",
    icon: BarChartIcon,
    to: "/reports"
  },
  {
    label: "Settings",
    icon: SettingsIcon,
    to: "/settings"
  }
];

export default navigationItems;

